
import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
    Standard: {

    ...genStandard("standard", "/api/therapy"),

    queryOidc:(staffId)=> {
        return get(`/api/md/staff/${staffId}/oidc`)
      },

    synchronizeInfo:(staffId, auCode)=> {
        return post(`/api/md/staff/synDoctor/${staffId}/${auCode}`)
     },

    item:(para)=>{
      if(para.id){
          return put(`/api/ml/item/${para.id}`,para)
       }
       return post(`/api/ml/item`,para)
     } 
     
  }
};
export default api;
